<template>
  <div>
    <a-autocomplete
      :items="options"
      item-text="label"
      item-value="id"
      @input="requirementResponse = $event"
      width="300px"
    />
    <transition name="fade">
      <div v-if="showTitleInput">
        <div class="spacer--l" />
        <span class="text--bold text--m">Provide a name for your project</span>
        <div class="spacer--m" />
        <text-field class="project-name-input" v-model="projectName" width="300px" />
      </div>
    </transition>
    <div class="spacer--l" />
    <transition name="fade">
      <a-btn v-if="requirementResponse && projectName" outlined @click="emitResponse">Next</a-btn>
    </transition>
  </div>
</template>

<script>
import AAutocomplete from "@/components/SelfService/a-autocomplete.vue";
import TextField from "@/components/SelfService/text-field.vue";
import ABtn from "@/components/SelfService/a-btn.vue";

export default {
  name: "SelfServiceVettingRunnerNodeRequirement",
  components: {ABtn, TextField, AAutocomplete},
  props: {
    options: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },
  data: () => ({
    projectName: null,
    requirementResponse: null,
    showTitleInput: false
  }),
  watch: {
    requirementResponse(newVal) {
      setTimeout(() => {
        this.showTitleInput = !!newVal;
      }, 200)
    }
  },
  methods: {
    emitResponse() {
      this.$emit('setProjectProperty', {key: 'name', value: this.projectName});
      this.$emit('capture', this.requirementResponse);
    }
  }
}
</script>

<style scoped lang="scss">
.project-name-input {
  position: unset;
}

// backwards navigation transition
.fade-enter-active {
  transition: opacity 0.3s, transform 0.3s ease-out;
}
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s ease-in;
}
.fade-enter {
  opacity: 0;
  //transform: translateY(-200%);
}
.fade-leave-to /* .slide-fade-leave-active in <2.1.8 */ {
  opacity: 0;
  //transform: translateY(200%);
}
</style>
